import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class HeaderService {
  showPartialDownTimeBanner = new Subject<boolean>();
  showCampaignBanner: boolean;

  constructor() {
    this.showCampaignBanner = false;
  }

  getShowCampaignBanner() {
    return this.showCampaignBanner;
  }

  setShowCampaignBanner(value: boolean) {
    this.showCampaignBanner = value;
  }

  setShowPartialDownTimeBanner(value: boolean): void {
    this.showPartialDownTimeBanner.next(value);
  }

  getShowPartialDownTimeBanner() {
    return this.showPartialDownTimeBanner.asObservable();
  }
}
